/** Safe post-login destination for `/provider?d=`. Does not inspect the token. */

export function safeProviderNext(next: string | null | undefined): string | null {
  if (!next || !next.startsWith("/provider")) return null;
  if (next.startsWith("//") || next.includes("://")) return null;
  return next;
}
